import React from 'react';

import { ContinueButton } from './ContinueButton';
import { CountrySelect } from './CountrySelect';
import { EmailInput } from './EmailInput';
import { PasswordInput } from './PasswordInput';
import { IndianStateSelect } from './IndianStateSelect';

interface EmailRegisterFormProps {
  email: string;
  password: string;
  displayName: string;
  country: string;
  stateCode: string;
  error: string | null | undefined;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onDisplayNameChange: (value: string) => void;
  onCountryChange: (value: string) => void;
  onStateCodeChange: (value: string) => void;
  onSubmit: (e?: React.FormEvent) => void;
  onBackToLogin: () => void;
}

// Helper component
const DisplayNameInput: React.FC<{
  value: string;
  onChange: (val: string) => void;
  disabled: boolean;
}> = ({ value, onChange, disabled }) => (
  <div className="input-group">
    <input
      type="text"
      className="auth-input"
      placeholder="Display Name"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  </div>
);

export const EmailRegisterForm: React.FC<EmailRegisterFormProps> = ({
  email,
  password,
  displayName,
  country,
  stateCode,
  error,
  isLoading,
  onEmailChange,
  onPasswordChange,
  onDisplayNameChange,
  onCountryChange,
  onStateCodeChange,
  onSubmit,
  onBackToLogin,
}) => (
  <form className="email-section" onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
    <EmailInput value={email} onChange={onEmailChange} disabled={isLoading} />
      
    <PasswordInput 
      value={password} 
      onChange={onPasswordChange} 
      disabled={isLoading} 
      placeholder="Password (min 8 chars)" 
    />

    <DisplayNameInput value={displayName} onChange={onDisplayNameChange} disabled={isLoading} />

    <div className="input-group">
      <CountrySelect
        value={country}
        onChange={(value) => onCountryChange(value)}
        disabled={isLoading}
      />
    </div>

    {country === 'IN' && (
      <div className="input-group mt-3">
        <IndianStateSelect
          value={stateCode}
          onChange={(e) => onStateCodeChange(e.target.value)}
          disabled={isLoading}
          required
        />
      </div>
    )}

    {error && <p className="auth-error-text">{error}</p>}

    <ContinueButton
      onClick={() => onSubmit()}
      isLoading={isLoading}
      disabled={!(email.trim() && password.length >= 8 && displayName.trim() && country && (country !== 'IN' || stateCode))}
    >
        Sign Up
    </ContinueButton>

    <button type="button" className="forgot-password-link email-register-back-btn" onClick={onBackToLogin}>
        Already have an account? Log in
    </button>
  </form>
);
